import { useTranslation } from 'react-i18next';
import { tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { formatRecordingsCount } from '../../utils/formatRecordingsCount';
import { useTotalHitsUpperBound } from '../../hooks/useTotalHitsUpperBound';

const CountSubtitle = styled.div`
  ${tokens.text('subtitle1')}
  color: ${tokens.nextColor.text_default};
`;

export interface RecordingsCountProps {
  count: number;
}

export const RecordingsCount = ({ count }: RecordingsCountProps): JSX.Element => {
  const { t } = useTranslation();
  const totalHitsUpperBound = useTotalHitsUpperBound();
  const countText = formatRecordingsCount(count, totalHitsUpperBound);

  return (
    <CountSubtitle data-testid="recordings-count">
      {countText} {t('common:recordings.list.recordings', { count })}
    </CountSubtitle>
  );
};
